export const AUTH_TOKEN = 'auth_token'
export const AUTH_TYPE = 'auth_type'
export const AUTH_ROLES = 'auth_roles'
export const AUTH_ID = 'auth_id'
export const AUTH_NAME = 'auth_name'
export const AUTH_USER = 'auth_user'
export const AUTH_SESSION_EXPIRY = 'expiresAt'
export const AUTH_DEVICE_TOKEN = 'devicetoken'
export const ADMIN_TYPE = 'Admin'
export const SUBADMIN_TYPE = 'Sub Admin'
export const EMPLOYER_TYPE = 'Employer'
export const BRANCH_TYPE = 'Branch'

/** Employer panel login: Employer + Branch. */
export const ALLOWED_LOGIN_USER_TYPES = [EMPLOYER_TYPE, BRANCH_TYPE]

export const isAllowedAdminPanelLoginType = (userType) =>
  ALLOWED_LOGIN_USER_TYPES.includes(userType)

export const isBranchUserType = (userType) => userType === BRANCH_TYPE

export const isEmployerUserType = (userType) => userType === EMPLOYER_TYPE

/** API path segment: employer vs branch-scoped resources. */
export const getApiUserScope = (userType) =>
  isBranchUserType(userType || localStorage.getItem(AUTH_TYPE))
    ? 'branch'
    : 'employer'

/** Nav / route keys a Branch user may access. */
export const BRANCH_ALLOWED_NAV_KEYS = [
  'dashboards-default',
  'shift',
  'shiftApplication',
  'timesheet',
]

export const BRANCH_ALLOWED_ROUTE_KEYS = [
  'dashboard.default',
  'dashboard-profile',
  'shift',
  'shiftApplication',
  'timesheet',
]

/** Sidebar items always visible (not in PermissionsConfig / role matrix). */
export const PUBLIC_NAV_KEYS = [
  'dashboards-default',
  'docs-documentation',
]

export const PASSWORD_FORM_RULES = [
  { required: true, message: 'Password is required' },
  { min: 8, message: 'Password must have at least 8 characters' },
  {
    pattern:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]+$/,
    message:
      'Password must contain uppercase, lowercase, number and special character (@$!%*?&#)',
  },
]
